<template>
  <form @submit.prevent="branchAction">
    <div class="row">
      <div class="col-sm-6 mb-3">
        <label>Name</label>
        <input
            v-model="branch.name"
            name="name"
            type="text"
            class="form-control py-3"
            :class="{
                    'is-invalid': v$.branch.name.$error,
                  }"
        />
        <p
            v-for="error of v$.branch.name.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Email</label>
        <input
            v-model="branch.email"
            name="name"
            type="email"
            class="form-control py-3"
            :class="{
                    'is-invalid': v$.branch.email.$error,
                  }"
        />
        <p
            v-for="error of v$.branch.email.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Phone Number</label>
        <phone-mask-input
            v-model="branch.phoneNumber"
            autoDetectCountry
            wrapperClass="d-flex justify-content-between"
            inputClass="form-control py-3 "
            :class="{ 'is-invalid': v$.branch.phoneNumber.$error}"
            flagClass="flag-example align-self-center"
        />
        <p
            v-for="error of v$.branch.phoneNumber.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Town</label>
        <input
            v-model="branch.town"
            name="name"
            type="text"
            class="form-control py-3"
            :class="{
                    'is-invalid': v$.branch.town.$error,
                  }"
        />
        <p
            v-for="error of v$.branch.town.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Street</label>
        <input
            v-model="branch.street"
            name="name"
            type="text"
            class="form-control py-3"
            :class="{
                    'is-invalid': v$.branch.street.$error,
                  }"
        />
        <p
            v-for="error of v$.branch.street.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Address Zone</label>
        <multiselect v-model="branch.zoneId" :options="zones.objects" :class="{
                        'is-invalid': v$.branch.zoneId.$error,
                  }" class="multiselect-height-3" placeholder="Select one" label="name" track-by="name"></multiselect>
        <p
            v-for="error in v$.branch.zoneId.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Address Line</label>
        <input
            v-model="branch.addressLine1"
            name="name"
            type="text"
            class="form-control py-3"
            :class="{
                    'is-invalid': v$.branch.addressLine1.$error,
                  }"
        />
        <p
            v-for="error of v$.branch.addressLine1.$errors"
            :key="error.$uid"
            class="invalid-feedback"
        >
          {{error.$message}}
        </p>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Automatic Discount Percentage</label>
        <input
            v-model="branch.automaticDiscountPrecentage"
            name="name"
            type="number"
            class="form-control py-3"
        />
      </div>
      <div class="col-sm-6 mb-3">
        <label>Automatic Surcharge Percentage</label>
        <input
            v-model="branch.automaticSurchargePrecentage"
            name="name"
            type="number"
            class="form-control py-3"
        />
      </div>
      <div class="col-sm-6 mb-3">
        <label>Person in Charge</label>
        <input
            v-model="branch.personInCharge"
            name="name"
            type="text"
            class="form-control py-3"/>
      </div>
      <div class="col-sm-6 mb-3">
        <label>Warehouse Consignee Code</label>
        <input
            v-model="branch.warehouseConsigneeCode"
            name="name"
            type="text"
            class="form-control py-3"/>
      </div>
      <div class="col-sm-12 mb-3">
        <label>Location</label>: [{{address.longitude}}, {{address.latitude}}]
        <vue-google-autocomplete v-if="selected_branch.publicId" id="edit_google_map" classname="form-control py-3" placeholder="Search location" country="ke" types="establishment"
                                 v-on:placechanged="getEditAddressData"></vue-google-autocomplete>
        <vue-google-autocomplete v-else id="map" classname="form-control py-3" placeholder="Search location" country="ke" types="establishment"
                                 v-on:placechanged="getAddressData"></vue-google-autocomplete>

      </div>
      <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
        {{error.message}}
      </div>
      <div class="mt-3 col-12">
        <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="loading">
          <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
          Loading
        </b-button>
        <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
          {{ button_text }}
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import PhoneMaskInput from  "vue-phone-mask-input";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Multiselect from "vue-multiselect";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {ALL_DELIVERY_ZONES} from "@/gql/system-settings";
import {mapGetters} from "vuex";

export default {
name: "branch-form",
  components: {Multiselect, VueGoogleAutocomplete, PhoneMaskInput},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      address: {
        longitude: this.selected_branch.longi,
        latitude: this.selected_branch.lat
      },
      branch: this.selected_branch,
      zones: {
        objects: []
      },
    }
  },
  validations () {
    return {
      branch: {
        addressLine1: {required},
        zoneId: {required},
        street: {required},
        town: {required},
        phoneNumber: {required},
        email: {required},
        name: {required},
      }
    }
  },
  props: {
    selected_branch: {
      type: Object,
      default () {
        return {
          location:"",
          addressLine1:"",
          zoneId:"",
          lat: "",
          longi: "",
          street:"",
          town:"",
          phoneNumber:"",
          email:"",
          name:"",
          automaticDiscountPrecentage: "",
          automaticSurchargePrecentage: "",
          personInCharge: "",
          warehouseConsigneeCode: "",
        }
      }
    },
    button_text: {type: String},
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  apollo: {
    zones: {
      query: ALL_DELIVERY_ZONES,
      variables (){
        return {
          page: 0,
          perPage: 30
        }
      }
    },
  },
  methods:{
    getAddressData: function (addressData) {
      this.address = addressData;
    },
    getEditAddressData: function (editaddressData) {
      this.address = editaddressData;
    },

    async branchAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        institutionId: this.$route.params.id,
        zoneId: this.branch.zoneId.publicId,
        name: this.branch.name,
        phoneNumber: this.branch.phoneNumber,
        email: this.branch.email,
        addressLine1: this.branch.addressLine1,
        town: this.branch.town,
        longi: String(this.address.longitude),
        lat: String(this.address.latitude),
        street: this.branch.street,
        automaticDiscountPrecentage: parseInt(this.branch.automaticDiscountPrecentage),
        automaticSurchargePrecentage: parseInt(this.branch.automaticSurchargePrecentage),
        personInCharge: String(this.branch.personInCharge),
        warehouseConsigneeCode: String(this.branch.warehouseConsigneeCode),
      }

      this.$emit('branchAction', data)
      this.v$.$touch();
    }
  }
}
</script>

<style>
.pac-container {
  z-index: 10000 !important;
}
</style>
